import { render, staticRenderFns } from "./DarkTheme.vue?vue&type=template&id=4a7924ed"
import script from "./DarkTheme.vue?vue&type=script&lang=js"
export * from "./DarkTheme.vue?vue&type=script&lang=js"
import style0 from "./DarkTheme.vue?vue&type=style&index=0&id=4a7924ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports